// extracted by LIB_CSS_EXTRACT_LOADER
import "./gradient-background_module.css"
export default {"root":"root-k726lA"};